export default {
    search: {
        clients: {
            items: null,
            pagination: {
                count: 0,
                limit: 10,
                offset: 0,
                totalCount: 0,
            },
            sortBy: ["client_fts.name:asc"],
            loading: true,
        },

        members: {
            items: null,
            pagination: {
                count: 0,
                limit: 10,
                offset: 0,
                totalCount: 0,
            },
            sortBy: [
            "members_client_fts.unaccented_member_first_name:asc",
            "members_client_fts.unaccented_member_last_name:asc",
            ],
            loading: true,
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/search/searchInitialState.js